export enum TemplateCategories {
  MOST_POPULAR = 'most-popular',
  SUBSCRIPTION_BASED_MOBILE_APPS = 'subscription-based-mobile-apps',
  ECOMMERCE_RETAIL = 'ecommerce_retail',
  GAMING = 'gaming',
  MEIDA = 'media',
  SAAS = 'saas'
}
